<template>
    <div v-if="question">
        <v-divider class="grey darken-4"/>
        <div class="pa-12px py-md-14px grey lighten-4">
            <strong class="font-size-16">Q. {{ question.subject }}</strong>
        </div>
        <v-divider />
        <div class="pa-12px py-md-14px">
            <span class="font-size-14 font-size-md-16"><strong class="font-weight-medium">작성일자</strong> : {{ $dayjs(question.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
        </div>
        <v-divider />

        <div class="font-size-14 font-size-md-16 pa-12px py-20px min-h-200px">
            <p v-html="question.content"></p>
        </div>
        <v-divider />

        <div class="font-size-14 font-size-md-16 pa-12px py-20px min-h-200px">
            <div class="mb-10px">
                <strong class="font-size-16">A. 관리자 답변</strong>
            </div>
            <p v-if="question.answer" v-html="question.answer"></p>
            <p v-else>관리자가 문의내용을 확인하고 있습니다.<br />조금만 기다려 주시면 성심성의껏 답변해 드리겠습니다.</p>
        </div>
        <v-divider />
    </div>
</template>

<script>
import api from "@/api";

export default {
    props: ["_id"],
    data(){
        return {
            question: null
        }
    },
	mounted() {
		this.init();
	},
	methods: {
		async init() {
            var { question } = await api.v1.me.center.questions.get({ _id: this.$route.params._question });
            this.question = question;
		},

        list(){
            this.$router.go(-1);
        },
	},
}
</script>
